"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));
var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _toggleBookmark = _interopRequireDefault(require("@micado-digital/react-bookmark/ReactBookmark/toggleBookmark"));
var _FallbackImage = _interopRequireDefault(require("@micado-digital/react-ui/components/FallbackImage"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _calculatePercentage = _interopRequireDefault(require("../../utils/calculatePercentage"));
var _fireEvent = _interopRequireDefault(require("../../utils/fireEvent"));
var _Price = _interopRequireDefault(require("../Price"));
var _Tags = _interopRequireDefault(require("../Tags"));
var _ProductTeaser = _interopRequireDefault(require("./ProductTeaser.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ProductTeaser = function ProductTeaser(_ref) {
  var _ref$displayedFeature = _ref.displayedFeatures,
    displayedFeatures = _ref$displayedFeature === void 0 ? [] : _ref$displayedFeature,
    lang = _ref.lang,
    product = _ref.product,
    showAttributes = _ref.showAttributes,
    showBookmark = _ref.showBookmark;
  var _ref2 = product || {},
    _ref2$attributes = _ref2.attributes,
    _attributes = _ref2$attributes === void 0 ? [] : _ref2$attributes,
    awardTag = _ref2.awardTag,
    awardTitle = _ref2.awardTitle,
    _ref2$combinationID = _ref2.combinationID,
    combinationID = _ref2$combinationID === void 0 ? 0 : _ref2$combinationID,
    description = _ref2.description,
    _ref2$features = _ref2.features,
    _features = _ref2$features === void 0 ? [] : _ref2$features,
    mediaList = _ref2.mediaList,
    pagename = _ref2.pagename,
    pageName = _ref2.pageName,
    price = _ref2.price,
    title = _ref2.title;
  var _ref3 = price || {},
    amount = _ref3.amount,
    originalAmount = _ref3.originalAmount,
    priceOption = _ref3.priceOption,
    scaleUnitAmount = _ref3.scaleUnitAmount,
    scaleUnitTitle = _ref3.scaleUnitTitle;
  var _useContext = (0, _react.useContext)(_ShopContext.default),
    shopData = _useContext.shopData;
  var css = (0, _ProductTeaser.default)();
  var tags = (0, _react.useMemo)(function () {
    var _tags = [];
    if (amount !== originalAmount) {
      _tags.push({
        color: "primary",
        tag: "discount",
        title: "".concat((0, _calculatePercentage.default)(amount, originalAmount), "%")
      });
    }
    if (awardTag && awardTitle) {
      _tags.push({
        color: "default",
        tag: awardTag,
        title: awardTitle
      });
    }
    return _tags;
  }, [amount, awardTag, awardTitle, originalAmount]);
  var link = (0, _react.useMemo)(function () {
    return "".concat(pageName !== null && pageName !== void 0 ? pageName : pagename).concat(combinationID ? "?combinationID=".concat(combinationID) : "");
  }, [combinationID, pageName, pagename]);
  var attributes = (0, _react.useMemo)(function () {
    var _attributes$map;
    return _attributes === null || _attributes === void 0 ? void 0 : (_attributes$map = _attributes.map(function (_ref4) {
      var title = _ref4.title,
        value = _ref4.value;
      return "<span>".concat(title, "</span>: ").concat(value);
    })) === null || _attributes$map === void 0 ? void 0 : _attributes$map.join(", ");
  }, [_attributes]);
  var features = (0, _react.useMemo)(function () {
    var _features$filter, _features$filter$map;
    return _features === null || _features === void 0 ? void 0 : (_features$filter = _features.filter(function (_ref5) {
      var identifier = _ref5.identifier;
      return displayedFeatures.indexOf(identifier) > -1;
    })) === null || _features$filter === void 0 ? void 0 : (_features$filter$map = _features$filter.map(function (_ref6) {
      var title = _ref6.title,
        value = _ref6.value;
      return "<span>".concat(title, "</span>: ").concat(value);
    })) === null || _features$filter$map === void 0 ? void 0 : _features$filter$map.join(", ");
  }, [_features, displayedFeatures]);
  var handleAddToBookmark = function handleAddToBookmark() {
    (0, _fireEvent.default)("add-to-bookmark", {
      product: product,
      shop: shopData
    });
  };
  var handleClick = function handleClick() {
    (0, _fireEvent.default)("select-item", {
      product: product,
      shop: shopData
    });
  };
  var handleRemoveFromBookmark = function handleRemoveFromBookmark() {
    (0, _fireEvent.default)("remove-from-bookmark", {
      product: product,
      shop: shopData
    });
  };
  return /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
    className: (0, _clsx.default)(css.productTeaser, "mco-shop-product-teaser"),
    to: link,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.image, "mco-shop-product-teaser__image-wrapper")
  }, !(0, _isEmpty.default)(mediaList) ? /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, {
    media: mediaList === null || mediaList === void 0 ? void 0 : mediaList[0],
    mediaFormats: {
      xs: "product-teaser"
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.fallbackImage, "mco-shop-product-teaser__fallback-image")
  }, /*#__PURE__*/_react.default.createElement(_FallbackImage.default, null)), !(0, _isEmpty.default)(tags) && /*#__PURE__*/_react.default.createElement(_Tags.default, {
    classNames: css.tags,
    tags: tags
  }), showBookmark && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.bookmark, "mco-shop-product-teaser__bookmark")
  }, /*#__PURE__*/_react.default.createElement(_toggleBookmark.default, {
    componentBookmarked: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentBookmarkedHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentDefault: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark.svg",
      size: 24
    }),
    componentHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    data: _objectSpread(_objectSpread({}, product), {}, {
      combinationID: combinationID
    }),
    validationFields: ["id", "combinationID", "objectType"],
    onAdded: handleAddToBookmark,
    onRemoved: handleRemoveFromBookmark
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-product-teaser__content")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.title, "mco-shop-product-teaser__title"),
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), description && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.description, "mco-shop-product-teaser__description"),
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), (!(0, _isEmpty.default)(features) || !(0, _isEmpty.default)(attributes)) && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.attributes, "mco-shop-product-teaser__attributes"),
    dangerouslySetInnerHTML: {
      __html: "".concat(!(0, _isEmpty.default)(features) ? features : "", " ").concat(!(0, _isEmpty.default)(features) && showAttributes && !(0, _isEmpty.default)(attributes) ? " - " : "", " ").concat(showAttributes && !(0, _isEmpty.default)(attributes) ? attributes : "")
    }
  }), /*#__PURE__*/_react.default.createElement(_Price.default, {
    classNames: css.price,
    amount: amount,
    lang: lang,
    originalAmount: originalAmount,
    priceOption: priceOption,
    scaleUnitAmount: scaleUnitAmount,
    scaleUnitTitle: scaleUnitTitle
  })));
};
var _default = ProductTeaser;
exports.default = _default;